import { Search, X } from "lucide-react";
import { L } from "@/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STATUS_OPTS = [
  ["all", "All statuses", "Todos os estados"],
  ["approved", "Approved", "Aprovados"],
  ["pending", "Pending", "Pendentes"],
  ["blocked", "Blocked", "Bloqueados"],
  ["rejected", "Rejected", "Rejeitados"],
];
const ROLE_OPTS = [
  ["all", "All roles", "Todos os perfis"],
  ["user", "Student (user)", "Aluno (user)"],
  ["admin", "Admin"],
];

const FilterSelect = ({ value, onChange, options, testId }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="h-10 w-full sm:w-48 bg-[#0f172a] border-slate-700 text-slate-200" data-testid={testId}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent className="bg-[#0f172a] border-slate-700 text-slate-200">
      {options.map(([v, l, p]) => (
        <SelectItem key={v} value={v} className="focus:bg-slate-800 focus:text-slate-50" data-testid={`${testId}-option-${v}`}>
          {L(l, p)}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export const UsersToolbar = ({ search, onSearch, status, onStatus, role, onRole }) => (
  <div className="flex flex-col sm:flex-row gap-3">
    <div className="relative flex-1">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
      <input
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        placeholder={L("Search by name, email or username…", "Pesquisar por nome, email ou username…")}
        className="w-full h-10 rounded-md bg-[#0f172a] border border-slate-700 pl-10 pr-9 text-sm text-slate-100 placeholder:text-slate-600 outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20 transition-colors"
        data-testid="users-search-input"
      />
      {search && (
        <button onClick={() => onSearch("")} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-200" data-testid="users-search-clear" aria-label={L("Clear", "Limpar")}>
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
    <FilterSelect value={status} onChange={onStatus} options={STATUS_OPTS} testId="users-status-filter" />
    <FilterSelect value={role} onChange={onRole} options={ROLE_OPTS} testId="users-role-filter" />
  </div>
);
